import validator from "validator/es/index";
import { isUserDataDuplicate } from "../API/user";
import { getOut } from "./Common";

function checkName(inputData) {
  /**
   * this function checks if the input value contains space, or minus or the german characters
   * @param inputData can be first name or last name
   * @returns false if the inputData contains something else than a minus, space or german character
   */
  let isvalid = true;
  inputData.split(/(?:[ -])+/).forEach((word) => {
    isvalid = isvalid && validator.isAlpha(word, "de-DE");
  });
  return isvalid;
}

export function handleFirstNameChange(newChangeData) {
  newChangeData = newChangeData.trim();
  let messageFirstname = checkName(newChangeData)
    ? ""
    : "Bitte eine gültige Vorname eintragen";
  return [newChangeData, messageFirstname];
}

export function handleLastNameChange(newChangeData) {
  newChangeData = newChangeData.trim();
  let messageLastname = checkName(newChangeData)
    ? ""
    : "Bitte eine gültige Nachname eintragen";
  return [newChangeData, messageLastname];
}

export async function handleEMailChange(newChangeData, initialEmail) {
  let messageEmail = { em: "" };
  const isvalid = validator.isEmail(newChangeData);
  if (!isvalid) {
    messageEmail["em"] = "Bitte eine gültige E-Mail-Adresse eintragen";
  } else if (newChangeData !== initialEmail) {
    let emailData = { em: newChangeData };
    messageEmail = await isUserDataDuplicate(0, emailData);
  }
  if (
    messageEmail.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`
  ) {
    getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
  }
  return [newChangeData, messageEmail["em"]];
}

export async function handleContactChange(newChangeData, initialContact) {
  let messageContact = { co: "" };
  const isvalid = validator.isNumeric(newChangeData, { no_symbols: true });
  if (!isvalid) {
    messageContact["co"] = "Bitte eine gültige Handynummer eintragen";
  } else if (newChangeData !== initialContact) {
    let contactData = { co: newChangeData };
    messageContact = await isUserDataDuplicate(1, contactData);
  }
  if (
    messageContact.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`
  ) {
    getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
  }
  return [newChangeData, messageContact["co"]];
}
